import { io } from 'socket.io-client';

let socket = null;

export function getCollabSocket() {
  if (socket) return socket;
  const token = localStorage.getItem('bos.access');
  if (!token) return null;
  const base = import.meta.env.VITE_API_BASE_URL || '';
  socket = io(`${base}/collab`, {
    path: '/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
  });
  return socket;
}

export function disconnectCollab() {
  if (socket) socket.disconnect();
  socket = null;
}

export function joinRoom(type, id) {
  const s = getCollabSocket();
  if (s && type && id) s.emit('join', { type, id });
}

export function leaveRoom(type, id) {
  const s = getCollabSocket();
  if (s && type && id) s.emit('leave', { type, id });
}

export function emitTyping(threadId, userName) {
  const s = getCollabSocket();
  if (s && threadId) s.emit('typing', { threadId, userName });
}

import { api } from './client.js';
const unwrap = (r) => r.data?.data;

export const collabApi = {
  activity: (params) => api.get('/activity', { params }).then(unwrap),
  searchUsers: (q) => api.get('/users/search', { params: { q } }).then(unwrap),
};
